export default function Footer() {
  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <footer className="w-full">
      {/* Newsletter & App Download - Top Tier */}
      <div className="w-full bg-background-100 text-foreground-700">
        <div className="w-full px-4 md:px-6 lg:px-8 py-8 md:py-10">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 lg:gap-12">
            {/* Left: Newsletter */}
            <div className="flex-1 max-w-xl">
              <div className="flex items-start gap-2 mb-3">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_db1e94dd529956a9cd4d4afc7c6999ce_1329fca5.jpg"
                alt="KenStore"
                className="h-9 w-auto rounded-md flex-shrink-0"
              />
                <div>
                  <h3 className="text-sm font-bold text-foreground-950 uppercase tracking-wide">
                    New to KenStore?
                  </h3>
                  <p className="text-sm text-foreground-600 mt-1 leading-relaxed">
                    Subscribe to our newsletter to get updates on our latest offers. You can unsubscribe at any time as described in our Privacy Policy.
                  </p>
                </div>
              </div>
              <p className="text-sm text-primary-600 mt-2 mb-3 hover:underline cursor-pointer">
                I accept the Legal Terms
              </p>
              <form onSubmit={handleNewsletterSubmit} className="flex flex-col gap-3">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input type="checkbox" className="mt-0.5 w-4 h-4 rounded border-background-300 bg-background-200 text-primary-500 focus:ring-primary-500" />
                  <span className="text-xs text-foreground-500 leading-relaxed">
                    I agree to KenStore&apos;s Privacy and Cookie Policy. You can unsubscribe from newsletters at any time.
                  </span>
                </label>
                <div className="flex flex-col sm:flex-row gap-2">
                  <div className="flex-1 relative">
                    <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500" />
                    <input
                      type="email"
                      placeholder="Enter E-mail Address"
                      className="w-full h-11 pl-10 pr-4 rounded-lg bg-background-50 text-foreground-950 text-sm placeholder:text-foreground-500 focus:outline-none focus:ring-2 focus:ring-primary-400"
                    />
                  </div>
                  <button
                    type="submit"
                    className="h-11 px-6 rounded-lg bg-background-50 text-foreground-950 font-semibold text-sm hover:bg-background-200 transition-colors whitespace-nowrap"
                  >
                    Subscribe
                  </button>
                </div>
              </form>
            </div>

            {/* Right: App Download */}
            <div className="flex items-start gap-4 flex-shrink-0">
              <div className="w-12 h-12 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-shopping-bag-3-line text-2xl text-background-50" />
              </div>
              <div>
                <h4 className="text-sm font-bold text-foreground-950 uppercase tracking-wide mb-1">
                  Download KenStore Free App
                </h4>
                <p className="text-sm text-foreground-600 mb-3">
                  Get access to exclusive offers!
                </p>
                <div className="flex items-center gap-2">
                  <a
                    href="/app"
                    rel="nofollow noopener"
                    className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-background-200 hover:bg-background-300 transition-colors"
                  >
                    <i className="ri-apple-fill text-lg text-foreground-700" />
                    <div className="leading-tight">
                      <p className="text-[10px] text-foreground-500 leading-none">Download on the</p>
                      <p className="text-xs text-foreground-700 font-semibold leading-none">App Store</p>
                    </div>
                  </a>
                  <a
                    href="/app"
                    rel="nofollow noopener"
                    className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-background-200 hover:bg-background-300 transition-colors"
                  >
                    <i className="ri-google-play-fill text-lg text-foreground-700" />
                    <div className="leading-tight">
                      <p className="text-[10px] text-foreground-500 leading-none">Get it on</p>
                      <p className="text-xs text-foreground-700 font-semibold leading-none">Google Play</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Link Columns - Middle Tier */}
      <div className="w-full bg-foreground-700 text-background-300">
        <div className="w-full px-4 md:px-6 lg:px-8 py-8 md:py-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {/* Need Help */}
            <div>
              <h4 className="text-xs font-bold text-background-50 uppercase tracking-wider mb-4">
                Need Help?
              </h4>
              <ul className="space-y-2.5">
                <li><a href="/faq" className="text-sm text-background-300 hover:text-background-50 transition-colors">Chat with us</a></li>
                <li><a href="/faq" className="text-sm text-background-300 hover:text-background-50 transition-colors">Help Center</a></li>
                <li><span className="text-sm text-background-300">Contact Us: 0700 000 000</span></li>
                <li><span className="text-sm text-background-300">Visit Us - Nairobi, Kenya</span></li>
              </ul>
            </div>

            {/* About KenStore */}
            <div>
              <h4 className="text-xs font-bold text-background-50 uppercase tracking-wider mb-4">
                About KenStore
              </h4>
              <ul className="space-y-2.5">
                <li><a href="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors">About us</a></li>
                <li><a href="/returns" className="text-sm text-background-300 hover:text-background-50 transition-colors">Returns and Refunds Policy</a></li>
                <li><a href="/careers" className="text-sm text-background-300 hover:text-background-50 transition-colors">KenStore Careers</a></li>
                <li><a href="/terms" className="text-sm text-background-300 hover:text-background-50 transition-colors">Terms and Conditions</a></li>
                <li><a href="/privacy" className="text-sm text-background-300 hover:text-background-50 transition-colors">Privacy Policy</a></li>
              </ul>
            </div>

            {/* Make Money */}
            <div>
              <h4 className="text-xs font-bold text-background-50 uppercase tracking-wider mb-4">
                Make Money with KenStore
              </h4>
              <ul className="space-y-2.5">
                <li><a href="/become-seller" className="text-sm text-background-300 hover:text-background-50 transition-colors">Sell on KenStore</a></li>
                <li><a href="/seller/dashboard" className="text-sm text-background-300 hover:text-background-50 transition-colors">Vendor Hub</a></li>
                <li><a href="/become-seller" className="text-sm text-background-300 hover:text-background-50 transition-colors">Become a Sales Consultant</a></li>
                <li><a href="/become-seller" className="text-sm text-background-300 hover:text-background-50 transition-colors">Become A KenStore Order Point</a></li>
              </ul>
            </div>

            {/* KenStore International */}
            <div>
              <h4 className="text-xs font-bold text-background-50 uppercase tracking-wider mb-4">
                KenStore International
              </h4>
              <ul className="space-y-2.5">
                <li><span className="text-sm text-background-300">Uganda</span></li>
                <li><span className="text-sm text-background-300">Tanzania</span></li>
                <li><span className="text-sm text-background-300">Rwanda</span></li>
                <li><span className="text-sm text-background-300">Ethiopia</span></li>
                <li><span className="text-sm text-background-300">South Sudan</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Methods, Social, Copyright - Bottom Tier */}
      <div className="w-full bg-foreground-700 text-background-300">
        <div className="w-full px-4 md:px-6 lg:px-8 py-6">
          {/* Payment Methods */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-xs text-background-400 uppercase tracking-wider mr-2">Payment Methods</span>
              <div className="h-8 px-2 rounded-md bg-background-50 flex items-center">
                <img
                  src="https://readdy.ai/api/search-image?query=M-Pesa%20mobile%20money%20payment%20service%20logo%20brand%20mark%20clean%20white%20background%20minimalist%20fintech%20Africa%20green%20color%20scheme%20professional%20sharp%20and%20recognizable%20simple%20design&width=200&height=60&seq=footer-mpesa-01&orientation=landscape"
                  alt="M-Pesa"
                  className="h-5 w-auto object-contain"
                  loading="lazy"
                />
              </div>
              <div className="h-8 px-2 rounded-md bg-background-50 flex items-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Airtel%20Money%20mobile%20payment%20service%20logo%20brand%20mark%20clean%20white%20background%20red%20color%20scheme%20fintech%20Africa%20professional%20sharp%20simple%20design%20minimalist&width=200&height=60&seq=footer-airtel-01&orientation=landscape"
                  alt="Airtel Money"
                  className="h-5 w-auto object-contain"
                  loading="lazy"
                />
              </div>
              <div className="h-8 px-2 rounded-md bg-background-50 flex items-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Visa%20credit%20card%20payment%20logo%20brand%20mark%20clean%20white%20background%20blue%20and%20gold%20color%20scheme%20minimalist%20financial%20services%20professional%20sharp%20simple&width=200&height=60&seq=footer-visa-01&orientation=landscape"
                  alt="Visa"
                  className="h-5 w-auto object-contain"
                  loading="lazy"
                />
              </div>
              <div className="h-8 px-2 rounded-md bg-background-50 flex items-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Mastercard%20payment%20logo%20brand%20mark%20clean%20white%20background%20red%20and%20orange%20circles%20minimalist%20financial%20services%20professional%20sharp%20simple%20design&width=200&height=60&seq=footer-mc-01&orientation=landscape"
                  alt="Mastercard"
                  className="h-5 w-auto object-contain"
                  loading="lazy"
                />
              </div>
              <div className="h-8 px-2 rounded-md bg-background-50 flex items-center">
                <img
                  src="https://readdy.ai/api/search-image?query=PayPal%20online%20payment%20logo%20brand%20mark%20clean%20white%20background%20blue%20color%20scheme%20minimalist%20fintech%20digital%20payment%20professional%20sharp%20simple&width=200&height=60&seq=footer-paypal-01&orientation=landscape"
                  alt="PayPal"
                  className="h-5 w-auto object-contain"
                  loading="lazy"
                />
              </div>
              <span className="px-3 py-1.5 rounded-md bg-background-50 text-xs text-foreground-700 font-medium">Cash on Delivery</span>
            </div>
          </div>

          {/* Social Icons + Copyright */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-4 border-t border-background-500/20">
            <div className="flex items-center gap-2">
              <span className="text-xs text-background-400 uppercase tracking-wider mr-2">Follow Us</span>
              <a href="https://facebook.com/kenstore" rel="nofollow noopener" className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center hover:opacity-80 transition-opacity">
                <img
                  src="https://readdy.ai/api/search-image?query=Facebook%20social%20media%20app%20icon%20logo%20brand%20mark%20white%20background%20blue%20color%20clean%20minimalist%20simple%20circle%20design&width=80&height=80&seq=footer-fb-01&orientation=squarish"
                  alt="Facebook"
                  className="w-5 h-5 object-contain"
                  loading="lazy"
                />
              </a>
              <a href="https://twitter.com/kenstore" rel="nofollow noopener" className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center hover:opacity-80 transition-opacity">
                <img
                  src="https://readdy.ai/api/search-image?query=Twitter%20X%20social%20media%20app%20icon%20logo%20brand%20mark%20white%20background%20black%20color%20clean%20minimalist%20simple%20design&width=80&height=80&seq=footer-x-01&orientation=squarish"
                  alt="Twitter / X"
                  className="w-5 h-5 object-contain"
                  loading="lazy"
                />
              </a>
              <a href="https://instagram.com/kenstore" rel="nofollow noopener" className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center hover:opacity-80 transition-opacity">
                <img
                  src="https://readdy.ai/api/search-image?query=Instagram%20social%20media%20app%20icon%20logo%20brand%20mark%20white%20background%20gradient%20pink%20purple%20orange%20clean%20minimalist%20simple&width=80&height=80&seq=footer-ig-01&orientation=squarish"
                  alt="Instagram"
                  className="w-5 h-5 object-contain"
                  loading="lazy"
                />
              </a>
              <a href="https://tiktok.com/@kenstore" rel="nofollow noopener" className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center hover:opacity-80 transition-opacity">
                <img
                  src="https://readdy.ai/api/search-image?query=TikTok%20social%20media%20app%20icon%20logo%20brand%20mark%20white%20background%20black%20pink%20cyan%20clean%20minimalist%20simple&width=80&height=80&seq=footer-tt-01&orientation=squarish"
                  alt="TikTok"
                  className="w-5 h-5 object-contain"
                  loading="lazy"
                />
              </a>
              <a href="https://youtube.com/kenstore" rel="nofollow noopener" className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center hover:opacity-80 transition-opacity">
                <img
                  src="https://readdy.ai/api/search-image?query=YouTube%20social%20media%20app%20icon%20logo%20brand%20mark%20white%20background%20red%20play%20button%20clean%20minimalist%20simple&width=80&height=80&seq=footer-yt-01&orientation=squarish"
                  alt="YouTube"
                  className="w-5 h-5 object-contain"
                  loading="lazy"
                />
              </a>
            </div>
            <p className="text-xs text-background-400 text-center sm:text-right">
              &copy; {new Date().getFullYear()} KenStore. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}